import { CircularProgress, ListItem, TextField } from 'material-ui';
import Fade from 'material-ui/transitions/Fade';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import { FormControlLabel } from 'material-ui/Form';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Radio from 'material-ui/Radio';
import getReportTypes from '../actions/getReportTypes';
import searchByAttribute from '../actions/searchByAttribute';
import searchAllPages from '../actions/searchAllPages';
import getCustomers from '../actions/getCustomers';
import getStateCountry from '../actions/getStateCountry';
import getCustomerGroups from '../actions/getCustomerGroups';

import Layout from '../components/Layout';
import { ProductMapReversed } from '../helpers/ProductMap';
import validationHelper from '../helpers/ValidationHelper';
import getUserLocations from '../actions/getUserLocations';
import { clearRoutes } from '../actions/getRoutes';
import AutoComplete from '../helpers/AutoComplete';
import RenderDialog from '../helpers/RenderDialog';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ComponentMap from '../helpers/ComponentMap';
import AutoCompleteOption from '../helpers/AutoCompleteOption';
import { config } from 'aws-sdk';
import { Slide } from '@material-ui/core';
import { slide } from 'react-burger-menu';
import {
  CheckCircle as SuccessIcon,
  Close as CloseIcon,
  Search as SearchIcon,
} from '@material-ui/icons';
import green from '@material-ui/core/colors/green';
import * as axios from 'axios';
import { Avatar, IconButton, InputAdornment, LinearProgress, Snackbar } from 'material-ui';
import { SnackbarContent } from 'material-ui/Snackbar';



const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
    justifyContent: 'center'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  paperStyle: {
    width: '40%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '10vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  success: {
    background: green[600],
    color: '#fff',
  },
  snack: {
    top: '16px',
  },
  snackMessage: {
    display: 'flex',
    alignItems: 'center',
  },
  snackContent: {
    background: 'green',
    color: '#fff',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    // boxShadow: '0px 4px 6px -2px rgba(0,0,0,0.1)',
    boxShadow: '1px 1px 5px 2px rgb(0 0 0 / 9%), 0px 2px 2px 0px rgb(0 0 0 / 12%), 0px 3px 1px -2px rgb(0 0 0 / 14%)',
    borderBottom: '1px solid #e0e0e0',
  },
  headerTitleStyle: {
    flexDirection: 'column',
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto'
  },
  productList: {
    display: 'flex',
    flexDirection: 'column !important',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '18px',
    marginTop: '25px',
    paddingLeft: '10px',
    paddingRight: '10px'
  },
  currentSelected: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly'
  },
});

const validate = (values) => {
  return validationHelper.validateRequired(['selectedProduct'], values);
};
const snackIcons = {
  success: SuccessIcon
};

class Selector extends Component {
  defaultProducts = ['AutoCheck Insurance', 'AutoCheck Auctions', 'VIN Cross Check'];
  state = {
    fetching: true,
    fetchingLocations: true,
    initialSet: false,
    prodChanged: false,
    locChanged: false,
    currentProduct: "None",
    currentLocation: "",
    currentCustomer: "",
    initialProduct: "",
    initialLocation: "",
    initialCustomer: "",
    buttonDisabled: true,
    openDialog: false,
    dialogMessage: ''
  };

  
  
  componentDidMount() {
    const locationId = localStorage.getItem('locationId');
    this.props.actions.getUserLocations(this.props.data.config, this);
    const selectedProduct = sessionStorage.getItem('product');
    const customerId = localStorage.getItem('customerId');
    this.setState({ currentCustomer: customerId });
    this.setState({ currentLocation: locationId });
    this.setState({ currentProduct: selectedProduct });

    if (!this.state.initialSet) {
      this.setState({ initialCustomer: customerId });
      this.setState({ initialLocation: locationId });
      this.setState({ initialProduct: selectedProduct });
      this.setState({ initialSet: true });
    }

    if (locationId) {
      let customerId = localStorage.getItem('customerId');
      
      if (this.props.data && this.props.data.locations) {
        const location = this.props.data.locations && this.props.data.locations.find(l => l.locationId === locationId);
        customerId = location.customerId;
        this.setState({ currentLocation: location.locationId });
      }
      
      this.props.actions.getAvailableProducts(locationId, customerId, this.props.data.config, this);
    } else {
      this.setState({ availableProducts: this.defaultProducts });
    }
  }

  setCustomer(locationId) {
      let locations = this.state.locations;
      let customerId = locations.filter(function (l) {
        return l.locationId === locationId;
      })[0].customerId;
    localStorage.setItem('customerId', customerId);
    this.setState({ currentCustomer: customerId, custChanged: true });
  }
  
  handleSave = (event) => {
    const { config } = this.props.data;
    this.props.actions.getLocationData(config);
    this.props.actions.getUsers(config);
    this.props.actions.getCustomers(config);
    this.props.actions.getCustomerGroups(config);
    this.props.actions.getPersonLocations(config);
    this.props.actions.getReportTypes(config);
    this.props.actions.getStateCountry(config);

    const { prodChanged, locChanged } = this.state;
    this.setState({ buttonDisabled: true });
    const bothChanged = (prodChanged && locChanged);
    if (bothChanged) {
      this.setState({ dialogMessage: 'Product and Location changed successfully!' });
    }
    sessionStorage.setItem('customer-list', null);
    sessionStorage.setItem('customer-group-list', null);
    sessionStorage.setItem('location-list', null);
    sessionStorage.setItem('user-list', null);
    this.setState({ openDialog: true });
  };

  //This handles the Cancel button logic.
  //On mount initial values are set. On cancel, it resets any changes made and reroutes.
  handleCancel = () => {
    const { locChanged, prodChanged, custChanged } = this.state;
    //Checks a boolean set up value change.
    //It then resets the value in session or local storage accordingly.
    if (prodChanged) {
      sessionStorage.setItem('product', this.state.initialProduct);
    }
    if (locChanged) {
      localStorage.setItem('locationId', this.state.initialLocation);
    }
    if (custChanged) {
      localStorage.setItem('customerId', this.state.initialCustomer);
    }
    this.props.actions.clearRoutes();
    this.props.history.push('/');
  };

  handleProductChange = (value) => {
    this.setState({buttonDisabled: false});
    this.setState({ dialogMessage: 'Product changed successfully!'});
    this.setState({ prodChanged: true });

    sessionStorage.setItem('product', value);
    this.setState({currentProduct: value });
    let locationId = localStorage.getItem('locationId');
    let customerId = localStorage.getItem('customerId');
    this.props.actions.getAvailableProducts(locationId, customerId, this.props.data.config, this);
  };

  handleChangedLocations = (value) => {
    this.setState({buttonDisabled: false});
    this.setState({ dialogMessage: 'Location changed successfully!'});
    this.setState({ locChanged: true });

    if(this.state.currentProduct !== this.state.initialProduct) {
      this.setState( {prodChanged: true } );
    }

    localStorage.setItem('locationId', value);
    this.setState({currentLocation: value });
    this.setCustomer(value);
    this.setState({fetching: true});
    let locationId = value;
    let customerId = localStorage.getItem('customerId');
    this.props.actions.getAvailableProducts(locationId, customerId, this.props.data.config, this);
  };

  renderLoadingAnimation = () => {
    const { fetching } = this.state;
    return (
        <Fade
            in={fetching}
            style={{
              transitionDelay: fetching ? '800ms' : '0ms'
            }}
            unmountOnExit
        >
          <CircularProgress style={{ marginTop: '10%' }} />
        </Fade>
    );
  };

  renderChangeDialog = () => {
    const { openDialog, dialogMessage } = this.state;
    const { classes } = this.props;
    return (
      <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          autoHideDuration={2000}
          open={openDialog}
          className={classes.snack}
          onClose={this.handleCloseDialog}
        >
          <SnackbarContent
          className={classes.snackContent}
            message={
              <span className={classes.snackMessage}>
                <SuccessIcon
                key="success"
                aria-label="success"
                color="inherit"
                style={{ marginRight: 24 }}
              />
              {dialogMessage}
              </span>
            }
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleCloseDialog}
              >
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Snackbar>
    );

  };
  
  handleCloseDialog = () => {
    this.sleep(500);
    this.setState({ openDialog: false });
    this.handleRedirect();
  }

  sleep(milliseconds) {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  }

  handleRedirect() {
    this.props.actions.clearRoutes();
    this.props.history.push('/');
  }
  
  renderCurrentSelected = () => {
    const { currentProduct, currentLocation } = this.state;
    const { classes } = this.props;
    let locationId = localStorage.getItem('locationId') ? localStorage.getItem('locationId') : "None";
    let selectedLocationName = currentLocation;
    let selectedProductName = currentProduct;

    //Set the initial name to none if a value isn't available
    if(!this.props.data.locations) {
      selectedLocationName = "None";
    } 
    //Otherwise filter the available locations to find the selected one
    else {
      let locations = this.props.data.locations;
      selectedLocationName = locations.filter(function (l) {
        return l.locationId === locationId;
      })[0].locationName;
    }

    if(!this.state.availableProducts.includes(selectedProductName)) {
        selectedProductName = this.state.availableProducts[0];
        sessionStorage.setItem('product', this.state.availableProducts[0]);
    }

    return(
      <div>
        <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title">
                Change Locations or Products
              </Typography>
        </Toolbar>
        <div className={classes.currentSelected + " row"}>
          <div className={"col-md-6"}>
            <Typography variant="headline">
              Location
            </Typography>
            <Typography variant="subheading">{selectedLocationName}</Typography>
          </div>
          <div className={"col-md-6"}>
            <Typography variant="headline">
              Product
            </Typography>
            <Typography variant="subheading">{selectedProductName}</Typography>
          </div>
        </div>
      </div>
    );
  };

  renderLocationSelector() {

    const { classes, handleSubmit } = this.props;
    const { locations } = this.state;
    const selectedSuggestions = localStorage.getItem('locationId');
    let suggestions = [];
    if (locations && Array.isArray(locations)) {
      suggestions = locations.map(l => ({
        value: l.locationId,
        label: l.locationId === selectedSuggestions ? "\u2713  " + l.locationName : l.locationName
      }));
    }
    
    
    return (
      <div>
        {
          <div>
            <AppBar position="static" className={classes.headerStyle}>
                <Toolbar className={classes.headerTitleStyle}>
                    <Typography variant="title">
                    Change Location
                    </Typography>
                </Toolbar>
              </AppBar>
            <div onSubmit={handleSubmit(this.handleSave)}>
              <Card className={classes.card}>
                <CardContent className={classes.content}>
                <div style={{ width: '100%', margin: '5%', zIndex: '1101'}}>
                    <AutoComplete
                      onChange={this.handleChangedLocations}
                      selectedSuggestions={selectedSuggestions}
                      suggestions={suggestions}
                      label="Locations"
                      placeholder="Select Location"
                    />
                  </div>
                </CardContent>
              </Card>
            </div>

          </div>
        }
      </div>  
    );
  }


  renderSelectorForm() {
    const { availableProducts, currentProduct, buttonDisabled } = this.state;
    const { classes, handleSubmit } = this.props;
    let selectedProduct = currentProduct;

    if(!availableProducts.includes(currentProduct) || availableProducts.length === 1) {
      selectedProduct = this.state.availableProducts[0];
      sessionStorage.setItem('product', selectedProduct);
  }

    let suggestions = [];
    if (availableProducts && Array.isArray(availableProducts)) {
      suggestions = availableProducts.map(product => ({
        value: product,
        label: (product === selectedProduct ? "\u2713  " + product : product)
      }));
    }
    
    return (
        <div>
            {this.renderCurrentSelected()}
            <Paper className={classes.paperStyle}>
            {this.renderLocationSelector()}
            <AppBar position="static" className={classes.headerStyle}>
                <Toolbar className={classes.headerTitleStyle}>
                <Typography variant="title">
                    Change Product
                </Typography>
                </Toolbar>
            </AppBar>
            <Form style={{width: '100%'}} onSubmit={handleSubmit(this.handleSave)}>
                <Card className={classes.card}>
                <CardContent className={classes.content}>
                    <div style={{ width: '100%', margin: '5%', marginBottom: '0%'}}>
                        <AutoComplete
                        onChange={this.handleProductChange}
                        selectedSuggestions={selectedProduct}
                        suggestions={suggestions}
                        label="Products"
                        placeholder="Select Product"
                        />
                    </div>
                </CardContent>
                </Card>
                <div className={classes.buttonRow + " row"}>
                    <div className={classes.buttonStyle + " col-md-6"}>
                    <Button variant="raised" color="primary" onClick={this.handleCancel} type="submit">Cancel</Button>
                    </div>
                    <div className={classes.buttonStyle + " col-md-6"}>
                    <Button variant="raised" color="primary" disabled={buttonDisabled} type="submit">Change</Button>
                    </div>
                </div>
                </Form>
            </Paper>
        </div>
    );
  }

  render() {
    const { fetching, fetchingLocations, openDialog } = this.state;

    return (
      <Layout className="App" showMenu menuTitle="Product Selector" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
        {
          openDialog
            ? this.renderChangeDialog()
            : null
        }
        {
          fetching || fetchingLocations
            ? this.renderLoadingAnimation()
            : this.renderSelectorForm()
        }
      </Layout>
    );
  }
}

Selector.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    login: state.login.login,
    locations: state.userLocations.userLocations
  }
});

const mapDispatchToProps = dispatch=> ({
  actions: {
    getReportTypes: (config) => {
      dispatch(getReportTypes(config));
    },
    getCustomerGroups: (config) => {
      dispatch(getCustomerGroups(config));
    },
    getPersonLocations: (config) => {
      dispatch(searchAllPages('person-locations', config))
    },
    getLocationData: (config) => {
      dispatch(searchAllPages('locations', config, true));
    },
    getCustomers: (config) => {
      dispatch(getCustomers(config));
    },
    getStateCountry: (config) => {
      dispatch(getStateCountry(config));
    },
    getUsers: (config) => {
      dispatch(searchAllPages('persons', config));
    },
    clearRoutes: () => clearRoutes(dispatch),
    closeDialog: () => {
        dispatch({
          type: 'DIALOG_CLOSED',
          payload: null
        });
    },
    getUserLocations: (config, self) => {
        dispatch(getUserLocations(config, self)).then((locations) => {
          const locationItems = locations.value.data.map(location => ({
            locationId: location.locationId,
            locationName: location.locationName,
            customerId: location.customerId,
          }));
          // sort them
          locationItems.sort((a, b) => a.locationName.localeCompare(b.locationName));
          self.setState({ locations: locationItems });
          self.setState({ fetchingLocations: false });
        });
    },
    getProductsByCustomerId: (customerId, config, self) => {
        const customerResult = dispatch(searchByAttribute('customers', 0, 'customerId', customerId, config, self));
        const { items: customers } = customerResult;
        
        const customer = customers.find(c => c.customerId === customerId);
        const { product: products } = customer;
        return products;
    },
    getAvailableProducts: async (locationId, customerId, config, self) => {
      /*
       * if we have a user location in redux store we will retrieve the customerId from there and the customerId
       * parameter will have a valid value. otherwise, we need to make another api call to get current location entity
       * and then get the customerId from the location. We'll then make another API call to get the current customer
       * entity which should have an array of products available to the current customer.
       */
      
      async function getCustomerIdByLocationId(locationId) {
        const locationResult = await dispatch(searchByAttribute('locations', 0, 'locationId', locationId, config, self));
        const { items: locations } = locationResult.value.data;
        
        const location = locations.find(c => c.locationId === locationId);
        const { customerId } = location;
        
        return customerId;
      }
      
      async function getProductsByCustomerId(customerId) {        
        const customerResult = await dispatch(searchByAttribute('customers', 0, 'customerId', customerId, config, self));
        const { items: customers } = customerResult.value.data;
        self.setState({availableCustomers: customers});
        let customer = customers.find(c => c.customerId === customerId);
        const { product: products } = customer;
        
        return products;
      }
      
      // if customerId is null/undefined, then API call to get customerId for the current location
      if (!customerId) customerId = getCustomerIdByLocationId(locationId);
      
      // get products for the current customer (based on current user's selected location)
      const customerProducts = await getProductsByCustomerId(customerId);
      if (!customerProducts || !customerProducts.length) {
        self.setState({ fetching: false, availableProducts: self.defaultProducts });
        return;
      }

      const availableProducts = customerProducts.map(p => ProductMapReversed[p]);
      
      //localStorage.setItem('showChangeProduct', true);
      if (!availableProducts || !availableProducts.length) {
        self.setState({ fetching: false, availableProducts: self.defaultProducts });
      } else if (availableProducts.length === 1) {
        
        sessionStorage.setItem('product', availableProducts[0]);
        self.setState({ currentProduct: availableProducts[0] });
        self.setState({ fetching: false, availableProducts });
        self.setState({ prodChanged: true });
      } else {
        self.setState({ fetching: false, availableProducts });
      }
    },
  }
});

const ConnectedSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: 'Selector', validate })(Selector));

export default withStyles(styles, { withTheme: true })(ConnectedSelector);


// WEBPACK FOOTER //
// ./src/containers/Selector.js